import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.978 0H1.761C.79 0 0 .79 0 1.76v5.87c0 .972.79 1.762 1.76 1.762h.588v1.76a.586.586 0 0 0 1.002.415l2.176-2.176h4.453c.97 0 1.76-.79 1.76-1.76V1.76c0-.97-.79-1.76-1.76-1.76V0ZM3.521 5.283a.587.587 0 1 1 0-1.174.587.587 0 0 1 0 1.174Zm2.935-.587a.587.587 0 1 1-1.173 0 .587.587 0 0 1 1.173 0Zm1.761.587a.587.587 0 1 1 0-1.174.587.587 0 0 1 0 1.174Z"
      fill="#040707"
    />
    <path
      d="M16.844 6.369a1.752 1.752 0 0 0-.605-.107h-3.885v1.37a2.379 2.379 0 0 1-2.376 2.375H6.261v3.885c0 .97.79 1.76 1.76 1.76h4.454l2.176 2.176a.581.581 0 0 0 .638.13.593.593 0 0 0 .363-.544v-1.761h.587c.97 0 1.761-.79 1.761-1.76v-5.87c0-.759-.482-1.407-1.156-1.654Zm-7.062 5.175a.587.587 0 1 1 0-1.173.587.587 0 0 1 0 1.173Zm2.935-.587a.587.587 0 1 1-1.173 0 .587.587 0 0 1 1.173 0Zm1.761.587a.587.587 0 1 1 0-1.173.587.587 0 0 1 0 1.173Z"
      fill="#040707"
    />
  </svg>
)

export default SvgComponent